import axios from 'axios';

export function getBrands(params) {
  return axios.post('/api/internal/example/list', params);
}
